import { render, staticRenderFns } from "./AjustesConsol.vue?vue&type=template&id=ca106614&scoped=true"
import script from "./AjustesConsol.vue?vue&type=script&lang=js"
export * from "./AjustesConsol.vue?vue&type=script&lang=js"
import style0 from "./AjustesConsol.vue?vue&type=style&index=0&id=ca106614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca106614",
  null
  
)

export default component.exports